export enum EPlanIntervalUnit {
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  LIFETIME = 'LIFETIME',
  SEMI = 'SEMI',
}

export enum EPlanIntervalCount {
  ONE = 1,
  SIX = 6,
}

export enum ECheckoutSource {
  premiumModal = 'premiumModal',
  purchasePage = 'purchasePage',
  lifeTimePage = 'lifeTimePage',
  limitedTimeDiscount = 'limitedTimeDiscount',
  onboarding = 'onboarding',
  plansA = 'plansA',
  plansB = 'plansB',
  plansC = 'plansC',
}

export enum EPaymentProvider {
  STRIPE = 'STRIPE',
  PAYPAL = 'PAYPAL',
}

export interface IPlanProvider {
  provider: EPaymentProvider;
  planId: string;
  productId: string;
}
export interface IPlan {
  plan_name: string;
  interval_unit: EPlanIntervalUnit;
  interval_count: EPlanIntervalCount;
  price: number;
  price_per_month: number;
  price_before_discount?: number;
  trial_period_in_days: number;
  status: string;
  currency: string;
  country: string;
  providers: IPlanProvider[];
}

export interface OrderInfoResponse {
  account_id: string;
}
export interface SubscriptionInfoResponse {
  account_id: string;
}

interface IStripePaymentResponse {
  purchaseId: string;
  clientSecret: string;
  status: string;
}
export type CreatePurchaseResponse = IStripePaymentResponse;
export type CreateSubscriptionResponse = IStripePaymentResponse;
